module.exports = __webpack_public_path__ + "static/img/a3.b5933502.png";